import { render } from "./ResendInviteDialog.vue?vue&type=template&id=95ad5584"
import script from "./ResendInviteDialog.vue?vue&type=script&lang=js"
export * from "./ResendInviteDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__